import { GET_USER_PERMISSIONS, GET_USER_ROLE_SUPERVISORS } from '../../types'
import { trackPromise } from 'react-promise-tracker'
const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const getUserPermissions = () => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/permissions`, options))

    if (!response.status || response.status === 401 || response.status === 404 || response.status === 500) {
      console.error('failed to get user permissions')
    } else {
      const { data } = await response.json()
      dispatch({
        type: GET_USER_PERMISSIONS,
        payload: data
      })
    }
  }
}

export const getRoleSupervisors = () => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/roles/supervisors`, options))

    if (!response.status || response.status === 401 || response.status === 404 || response.status === 500) {
      console.error('Failed to get role supervisor information')
    } else {
      const { data } = await response.json()
      dispatch({
        type: GET_USER_ROLE_SUPERVISORS,
        payload: data
      })
    }
  }
}

export const createNewSupervisor = (selectedUser, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const body = { ...selectedUser }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/new`, options))
    if (!response.status || ![200, 204].includes(response.status)) {
      fireFailure(response.status)
      return false
    } else {
      const { data } = await response.json()
      fireSuccess(data?.previousSupervisor)
      return true
    }
  }
}

export const updateExistingSupervisor = (selectedUser, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const body = { ...selectedUser }

    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/update`, options))
    if (!response.status || response.status === 401 || response.status === 404 || response.status === 500 ||
      response.status === 400) {
      fireFailure()
      return false
    } else {
      fireSuccess()
      return true
    }
  }
}

export const deleteExistingSupervisor = (supervisorID, adminConfig, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const body = { ...adminConfig }

    const options = {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/delete`, options))
    if (!response.status || response.status === 401 || response.status === 404 || response.status === 500 ||
      response.status === 400) {
      fireFailure()
      return false
    } else {
      fireSuccess()
      return true
    }
  }
}

export const createBatchSupervisors = (batchUsers, sendOnboardingEmail, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const body = { batchUsers, sendOnboardingEmail }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/supervisors/${supervisorID}/file`, options))
    if (!response.status || response.status === 401 || response.status === 404 || response.status === 500 ||
      response.status === 400) {
      fireFailure()
      return false
    } else {
      fireSuccess()
      return true
    }
  }
}
